export default __webpack_public_path__ + "static/media/companies-experts-financial-education.a35850d3.svg";